/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import PropTypes from 'prop-types';
import { Badge as SuiBadge } from '@one-thd/sui-atomic-components';
import { BADGE_TEXT } from '../../constants';

export const Badge = ({ text }) => {
  // note: background color could be replace later for the closest one in stencil(sui-bg-info-strong)
  // for now to get the same as in old badge.
  const isEventBadge = text === BADGE_TEXT.EVENT;
  const isProPickBadge = text === BADGE_TEXT.PRO_PICK;
  const isChristmasBadge = text === BADGE_TEXT.CHRISTMAS;
  const isPurchasedBadge = text?.startsWith(BADGE_TEXT.PURCHASED);

  let variant = 'regular';
  let badgeColor = 'info';

  switch (true) {
    case isEventBadge:
      badgeColor = 'brand';
      break;
    case isChristmasBadge:
      badgeColor = 'success';
      variant = 'strong';
      break;
    case isProPickBadge:
      badgeColor = 'primary';
      variant = 'strong';
      break;
    case isPurchasedBadge:
      variant = 'outline';
      break;
    default:
      break;
  }

  return (
    <SuiBadge variant={variant} color={badgeColor} size="small">{text}</SuiBadge>
  );
};

Badge.propTypes = {
  text: PropTypes.string.isRequired,
};
